import LandingPageScrollFeatures from '@/app/components/LandingPage/LandingPageScrollFeatures';

import { partnershipOfferingsData } from '../_data/partnershipOfferingsData';

const PartnershipsOfferings = () => {
  return (
    <section data-cy="partnerships-explore">
      <LandingPageScrollFeatures
        title="partnerships_offerings_title"
        eyebrow="partnerships_offerings_eyebrow"
        tabs={partnershipOfferingsData}
      />
    </section>
  );
};

export default PartnershipsOfferings;
